export default __webpack_public_path__ + "static/media/on-thepitch.065662f5.svg";